import { useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Baby, Heart, Mountain, Utensils, Briefcase, Backpack, Palmtree, Users, Sparkles, Fish } from 'lucide-react';
import OceanBackground from '@/components/background/OceanBackground';

const templates = [
  { icon: Baby, title: '亲子游', desc: '寓教于乐，全家欢乐', tag: 'family', img: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=400&q=65', color: 'cl' },
  { icon: Heart, title: '情侣蜜月', desc: '浪漫打卡，甜蜜之旅', tag: 'couple', img: 'https://images.unsplash.com/photo-1474552226712-ac0f0961a954?w=400&q=65', color: 'cp' },
  { icon: Mountain, title: '小众徒步', desc: '探索秘境，挑战自我', tag: 'hiking', img: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=400&q=65', color: 'cs' },
  { icon: Utensils, title: '美食探店', desc: '舌尖上的旅行', tag: 'food', img: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=400&q=65', color: 'ca' },
  { icon: Palmtree, title: '轻奢度假', desc: '高品质慢生活', tag: 'luxury', img: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&q=65', color: 'cl' },
  { icon: Backpack, title: '穷游学生', desc: '高性价比省钱攻略', tag: 'budget', img: 'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=400&q=65', color: 'cg' },
  { icon: Briefcase, title: '公司团建', desc: '团队协作，凝聚力', tag: 'team', img: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400&q=65', color: 'cm' },
  { icon: Users, title: '父母出游', desc: '舒适节奏，贴心安排', tag: 'elderly', img: 'https://images.unsplash.com/photo-1545558014-8692077e9b5c?w=400&q=65', color: 'cs' },
];

const Templates = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative" style={{ background: 'linear-gradient(180deg, #101a30 0%, #162544 50%, #101a30 100%)' }}>
      <Navbar />
      <OceanBackground />
      <div className="max-w-6xl mx-auto px-4 md:px-6 pt-28 pb-20 relative z-10">
        <div className="text-center mb-16" style={{ animation: 'rise .75s ease-out both' }}>
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full" style={{ background: 'rgba(61,130,176,0.1)', border: '1px solid rgba(61,130,176,0.2)' }}>
            <span className="text-[12px] cg">🐋 8 套场景模板</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold cb mt-6 mb-4 is">精选旅行场景</h1>
          <p className="text-lg cm max-w-lg mx-auto">每一套模板都经过精心设计，适配不同出行场景</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {templates.map((t, idx) => (
            <button
              key={t.tag}
              onClick={() => navigate('/planner', { state: { template: t.tag } })}
              className="frost overflow-hidden cursor-pointer text-left"
              style={{ animation: `rise .75s ease-out ${idx * 0.07}s both` }}
            >
              <div className="relative aspect-[4/5]" style={{ background: 'linear-gradient(135deg, #1e3860, #2d5082)' }}>
                <img src={t.img} alt={t.title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" onError={(e) => e.target.style.display = 'none'} style={{ zIndex: 1 }} />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, transparent 30%, rgba(16,26,48,0.95))', zIndex: 2 }} />
                <div className="absolute bottom-0 left-0 right-0 p-4" style={{ zIndex: 3 }}>
                  <h3 className="font-bold text-lg cb">{t.title}</h3>
                  <p className="text-[12px] cm mt-0.5">{t.desc}</p>
                </div>
                <div className="absolute top-3 right-3 ls ls-tl" style={{ zIndex: 3 }}>
                  <Fish className="w-3 h-3" /> {t.tag}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Templates;
